const visitorTypes = {
    TOP_LEVEL_SIMPLE_TRANSFORMATION: 'TopLevelSimpleTransformationExpression',
    TOP_LEVEL_CUSTOM_FUNCTION: 'TopLevelCustomFunctionExpression',
    NESTED_UNSUPPORTED_TRANSFORMATION: 'NestedUnsupportedTransformationExpression',
    TOP_LEVEL_UNSUPPORTED_TRANSFORMATION: 'TopLevelUnsupportedTransformationExpression',
    NESTED_SPREAD: 'NestedSpreadExpression',
    TOP_LEVEL_SPREAD: 'TopLevelSpreadExpression',
    CUSTOM_FUNCTION: 'CustomFunctionExpression',
    NESTED_SIMPLE_TRANSFORMATION: 'NestedSimpleTransformationExpression',
    MAP_ARRAY_ITEMS: 'MapArrayItems',
    TOP_LEVEL_MAP_ARRAY_ITEMS: 'TopLevelMapArrayItems',
    TOP_LEVEL_OMIT_TRANSFORMATION: 'TopLevelOmit',
    NESTED_OMIT_TRANSFORMATION: 'NestedOmit',
    NESTED_CONSTANT_VALUE: 'NestedConstantValue',
};
const JSON_PATH_ROOT = '$';
export { JSON_PATH_ROOT, visitorTypes };
//# sourceMappingURL=constants.js.map